import { render, staticRenderFns } from "./Provider.vue?vue&type=template&id=6fe064cf"
import script from "./Provider.js?vue&type=script&lang=js&external"
export * from "./Provider.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports